module.exports = __webpack_public_path__ + "img/31.6e46e5e3.jpg";